export enum NETWORK_NAMES {
  TESTNET = "Test network",
  PUBNET = "Public network",
}

export enum NETWORKS {
  PUBLIC = "PUBLIC",
  TESTNET = "TESTNET",
}
